"use strict";

/**
 * Removes the openChat parameter from the current URL.
 */
function cleanUrlFlag() {
    if (!window.history || !window.history.replaceState) {
        return;
    }

    var url = new URL(window.location.href);
    url.searchParams.delete("openChat");
    window.history.replaceState({}, document.title, url.toString());
}

/**
 * Tries to open the Botmaker chat by clicking the button inside the iframe.
 *
 * @param {jQuery} $iframe - Botmaker iframe.
 * @returns {boolean} - true if the chat was opened, false otherwise.
 */
function tryOpenChat($iframe) {
    if (!$iframe || !$iframe.length) {
        return false;
    }

    var $button = $iframe.contents().find(".wc-button-minimized");

    if (!$button.length) {
        return false;
    }

    $button[0].click();
    cleanUrlFlag();

    return true;
}

/**
 * Observes the document inside the iframe until the chat button appears,
 * then opens the chat. The button is rendered inside the iframe, so mutations
 * happen in its inner document — not in the parent page body.
 *
 * @param {HTMLElement} iframe - Botmaker iframe element.
 */
function observeInsideIframe(iframe) {
    if (tryOpenChat($(iframe))) {
        return;
    }

    var innerDoc = iframe.contentDocument || (iframe.contentWindow && iframe.contentWindow.document);

    if (!innerDoc || !innerDoc.body) {
        return;
    }

    var innerObserver = new MutationObserver(function () {
        if (tryOpenChat($(iframe))) {
            innerObserver.disconnect();
        }
    });

    innerObserver.observe(innerDoc.body, { childList: true, subtree: true });
}

/**
 * Attaches the inner observer to the iframe, waiting for its document to be
 * ready first when needed.
 *
 * @param {HTMLElement} iframe - Botmaker iframe element.
 */
function handleIframe(iframe) {
    if (iframe.contentDocument && iframe.contentDocument.body) {
        observeInsideIframe(iframe);
        return;
    }

    iframe.addEventListener("load", function () {
        observeInsideIframe(iframe);
    });
}

/**
 * Watches the parent page for the Botmaker iframe to appear, then delegates
 * to the inner observer. The parent-body observer is used only to detect the
 * iframe itself, since iframe content mutations don't reach the parent.
 */
function waitForChat() {
    if (tryOpenChat($("iframe[name='Botmaker']"))) {
        return;
    }

    var iframe = document.querySelector("iframe[name='Botmaker']");

    if (iframe) {
        handleIframe(iframe);
        return;
    }

    var bodyObserver = new MutationObserver(function () {
        var found = document.querySelector("iframe[name='Botmaker']");

        if (found) {
            bodyObserver.disconnect();
            handleIframe(found);
        }
    });

    bodyObserver.observe(document.body, { childList: true, subtree: true });
}

/**
 * Opens the Botmaker chat automatically when the page is loaded with the
 * openChat=true URL parameter (e.g. from an email link). Does not initialize
 * the chat widget itself — it only triggers the existing widget to open.
 */
function autoOpenChatFromUrl() {
    var params = new URLSearchParams(window.location.search);

    if (params.get("openChat") !== "true") {
        return;
    }

    waitForChat();
}

export default autoOpenChatFromUrl;
